/* eslint-disable no-underscore-dangle */
import { NumericEditor } from 'handsontable/editors/numericEditor';

/**
 * Этот хак нужен для того что бы дать понять TS'у что у базовой реализации редакторов
 * есть защищённый метод, который вызвается после окончания редактирования ячейки.
//  */
declare module 'handsontable/editors/baseEditor' {
  export interface BaseEditor {
    _fireCallbacks(result: boolean): void;
  }
}

/**
 * Редактор для ячеек таблицы, который приводит пустую строку к Null
 */
export default class EmptyToNullEditor extends NumericEditor {
  protected INVALID_CELL_TEXT_COLOR: string = 'white';

  protected INVALID_CELL_BACKGROUND_COLOR: string = '#f19c94';

  INVALID_TOOLTIP: HTMLElement | null = null;

  protected INVALID_TOOLTIP_TEXT =
    'У данной ячейки значением может быть только число. ' +
    'Для выхода из режима редактирования нажмите Esc.';

  getValue(): null | number {
    const value = NumericEditor.prototype.getValue.call(this);
    return value === '' ? null : +value;
  }

  /**
   * Помечаем ячейку с недопустимым значением.
   *
   * @protected
   */
  protected setInvalid(): void {
    this.TEXTAREA.style.backgroundColor =
      this.cellProperties.invalidCellBackgroundColor ?? this.INVALID_CELL_BACKGROUND_COLOR;
    this.TEXTAREA.style.color =
      this.cellProperties.invalidCellTextColor ?? this.INVALID_CELL_TEXT_COLOR;
    if (this.cellProperties.raiseInvalidTooltip !== false) {
      this.raiseTooltip();
    }
  }

  _fireCallbacks(result: boolean) {
    super._fireCallbacks(result);
    if (!result) {
      this.setInvalid();
    } else {
      this.setValid();
    }
  }

  /**
   * Показываем всплывающую подсказку с описанием того что пользователь
   * делает не так и почему ячейка не валидна.
   * @private
   */
  protected raiseTooltip(): void {
    if (this.INVALID_TOOLTIP) {
      return;
    }
    this.INVALID_TOOLTIP = document.createElement('div');
    this.INVALID_TOOLTIP.textContent =
      this.cellProperties.invalidTooltipText ?? this.INVALID_TOOLTIP_TEXT;
    this.INVALID_TOOLTIP.style.backgroundColor = '#fcffae';
    this.INVALID_TOOLTIP.style.width = '300px';
    this.INVALID_TOOLTIP.style.padding = '2px 4px';
    this.INVALID_TOOLTIP.style.position = 'absolute';
    this.INVALID_TOOLTIP.style.border = '1px solid grey';
    this.INVALID_TOOLTIP.style.left = '100%';
    this.INVALID_TOOLTIP.style.borderRadius = '8px';
    this.INVALID_TOOLTIP.style.borderRadius = '8px 8px 8px 0';
    const container = document.createElement('div');
    container.style.position = 'relative';
    container.append(this.INVALID_TOOLTIP);
    this.TEXTAREA_PARENT.prepend(container);
    this.TEXTAREA_PARENT.style.zIndex = '161';
    if (this.instance.container.parentElement) {
      this.instance.container.parentElement.style.overflow = 'unset';
    }
    this.INVALID_TOOLTIP.style.top = `-${this.INVALID_TOOLTIP.clientHeight}px`;
  }

  /**
   * Устанавливаем статус валидности для поля ввода ячейки
   * @protected
   */
  protected setValid(): void {
    this.TEXTAREA.style.backgroundColor = '';
    this.TEXTAREA.style.color = '';
    this.TEXTAREA_PARENT.style.zIndex = '';
    if (this.instance.container.parentElement) {
      this.instance.container.parentElement.style.overflow = 'hidden';
    }
    if (this.INVALID_TOOLTIP) {
      this.INVALID_TOOLTIP.parentElement?.remove();
      this.INVALID_TOOLTIP = null;
    }
  }
}
